import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDefaultProfileId, setDefaultProfileId } from "../../slices/bp";
export const useDefaultProfileId = () => {
    const dispatch = useDispatch();
    const defaultProfileId = useSelector(getDefaultProfileId);
    const update = useCallback((value) => {
        dispatch(setDefaultProfileId(value));
    }, [dispatch]);
    return [defaultProfileId, update];
};
